import { render } from "./RoundResults.vue?vue&type=template&id=6f6b8373&scoped=true"
import script from "./RoundResults.vue?vue&type=script&lang=js"
export * from "./RoundResults.vue?vue&type=script&lang=js"

import "./RoundResults.vue?vue&type=style&index=0&id=6f6b8373&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6b8373"]])

export default __exports__